import ReportsSerializer from './base';

export default class ReportTemplateSection extends ReportsSerializer {}
